import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { UserItemModel } from 'src/app/models/user/user-item.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: false
})
export class UsersComponent extends BasePagedPage<string, UserItemModel> implements OnInit {
  constructor(private mApiService: ApiService, private mRouter: Router) {
    super();
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<UserItemModel>>('/api/admin/user/manager/list', {
      page: page ?? 1,
      pageSize: this.pageSize,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public addNew() {
    this.mRouter.navigate(['/users/edit/new']);
  }

  public deleteItem(id: string) {
    if (!confirm('Удалить пользователя?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/user/manager/${id}`).subscribe({
      next: () => {
        this.getData(this.page);
      }, error: () => this.isBusy = false
    });
  }

}
